import { gql } from '@apollo/client';

export default gql`
  fragment CoderConnectionEventFields on CoderConnectionEvent {
    type
    timestamp
    __typename
  }
`;
